import { Component } from '@angular/core';
import { EnumScales } from '@library/store/measures/measures.interface';
import { CpCompareScaleService } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-header/cp-compare-scale/cp-compare-scale.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-cp-compare-scale',
  templateUrl: './cp-compare-scale.component.html',
  styleUrls: ['./cp-compare-scale.component.scss']
})
export class CpCompareScaleComponent {

  viewModel$ = combineLatest({
    scale: this.compareScaleService.scale$,
  });

  constructor(
    private compareScaleService: CpCompareScaleService,
  ) {}

  selectScale(scale: EnumScales) {
    this.compareScaleService.setScale(scale);
  }

}
